module.exports = __webpack_public_path__ + "img/calendar.a6067f1d.svg";